import styled from 'styled-components';

export const Contents = styled.ul`
  display: grid;
  flex-direction: column;
  flex-wrap: nowrap;
  overflow-x: scroll;

  li {
    display: grid;
    flex-direction: column;
    border-bottom: 1px solid #f2f2f2;

    .game {
      display: flex;
      align-items: center;
      height: 52px;

      &.noneBorder {
        border: none;
      }

      span {
        font-size: 13px;
      }
    }
  }
`;

export const Header = styled.li`
  height: 36px;
  border-bottom: 1px solid #f2f2f2;
  font-size: 11px;
  color: #333333;

  & > div {
    display: flex;
    justify-content: center;

    span {
      font-size: 11px !important;
      color: #333333 !important;
    }
  }

  .game {
    height: 36px !important;

    .date {
      width: 40px;
      min-width: 40px;
      margin-left: 15px;
    }
  }
`;

export const Date = styled.div`
  width: 40px;
  min-width: 40px;
  margin-left: 15px;
  font-size: 13px;
  font-weight: 300;
`;

export const Location = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 260px;

  .team {
    flex: 1;
    display: flex;
    flex-direction: column;
    /* min-width: 88px; */

    &.home {
      justify-content: flex-end;

      span {
        text-align: right;
      }
    }

    span {
      font-size: 13px;
      font-weight: normal;
      color: #222222;
    }

    span:last-child {
      font-size: 10px;
      color: #999999;
    }
  }

  .score {
    box-sizing: border-box;
    position: relative;
    display: flex;
    min-width: 98px;
    padding: 0px 20px;

    p {
      width: 20px;
      text-align: center;
      font-size: 18px;
    }

    span {
      font-size: 18px;
    }

    .on {
      color: #ed2026;
    }

    .scoreCenter {
      margin: 0px 6px;
    }
  }
`;

export const Odds = styled.div`
  display: flex;
  justify-content: center;
  max-width: 120px;
  width: 120px;

  .oddsItem {
    width: 32px;
    min-width: 32px;
    height: 15px;
    margin-right: 4px;
    border-radius: 15px;
    font-size: 9px !important;
    line-height: 15px;
    text-align: center;

    &.home {
      border: solid 1px #ed2026;
      color: #ed2026;
    }

    &.away {
      border: solid 1px #2a83ff;
      color: #2a83ff;
    }
  }
`;
